import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * React Router keeps scroll position across navigations by default.
 * Scroll the window to the top whenever the location pathname changes.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
